import React from 'react';

export const chevronLeft = (props) => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g id='Group'>
        <path
          id='Vector'
          d='M9.02341 9.99999L13.1484 14.125L11.9701 15.3033L6.66675 9.99999L11.9701 4.69666L13.1484 5.87499L9.02341 9.99999Z'
          fill='#234E52'
        />
      </g>
    </svg>
  );
};

export const chevronRight = (props) => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.9766 9.99999L6.85156 5.87499L8.0299 4.69666L13.3332 9.99999L8.0299 15.3033L6.85156 14.125L10.9766 9.99999Z'
        fill='#234E52'
      />
    </svg>
  );
};

export const chevronLeftOutline = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M8.41421 12L15.7071 19.2929C16.0976 19.6834 16.0976 20.3166 15.7071 20.7071C15.3166 21.0976 14.6834 21.0976 14.2929 20.7071L6.29289 12.7071C5.90237 12.3166 5.90237 11.6834 6.29289 11.2929L14.2929 3.29289C14.6834 2.90237 15.3166 2.90237 15.7071 3.29289C16.0976 3.68342 16.0976 4.31658 15.7071 4.70711L8.41421 12Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const chevronRightOutline = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M15.5858 12L8.29289 4.70711C7.90237 4.31658 7.90237 3.68342 8.29289 3.29289C8.68342 2.90237 9.31658 2.90237 9.70711 3.29289L17.7071 11.2929C18.0976 11.6834 18.0976 12.3166 17.7071 12.7071L9.70711 20.7071C9.31658 21.0976 8.68342 21.0976 8.29289 20.7071C7.90237 20.3166 7.90237 19.6834 8.29289 19.2929L15.5858 12Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const chevrons2LeftOutline = (props) => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M8.41421 14L14.2071 19.7929C14.5976 20.1834 14.5976 20.8166 14.2071 21.2071C13.8166 21.5976 13.1834 21.5976 12.7929 21.2071L6.29289 14.7071C5.90237 14.3166 5.90237 13.6834 6.29289 13.2929L12.7929 6.79289C13.1834 6.40237 13.8166 6.40237 14.2071 6.79289C14.5976 7.18342 14.5976 7.81658 14.2071 8.20711L8.41421 14Z'
        fill='#023F80'
      />
      <path
        d='M16.4142 14L22.2071 19.7929C22.5976 20.1834 22.5976 20.8166 22.2071 21.2071C21.8166 21.5976 21.1834 21.5976 20.7929 21.2071L14.2929 14.7071C13.9024 14.3166 13.9024 13.6834 14.2929 13.2929L20.7929 6.79289C21.1834 6.40237 21.8166 6.40237 22.2071 6.79289C22.5976 7.18342 22.5976 7.81658 22.2071 8.20711L16.4142 14Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const chevrons2RightOutline = (props) => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M20.0858 14L14.2929 8.20711C13.9024 7.81658 13.9024 7.18342 14.2929 6.79289C14.6834 6.40237 15.3166 6.40237 15.7071 6.79289L22.2071 13.2929C22.5976 13.6834 22.5976 14.3166 22.2071 14.7071L15.7071 21.2071C15.3166 21.5976 14.6834 21.5976 14.2929 21.2071C13.9024 20.8166 13.9024 20.1834 14.2929 19.7929L20.0858 14Z'
        fill='#023F80'
      />
      <path
        d='M12.0858 14L6.29289 8.20711C5.90237 7.81658 5.90237 7.18341 6.29289 6.79289C6.68342 6.40237 7.31658 6.40237 7.70711 6.79289L14.2071 13.2929C14.5976 13.6834 14.5976 14.3166 14.2071 14.7071L7.70711 21.2071C7.31658 21.5976 6.68342 21.5976 6.29289 21.2071C5.90237 20.8166 5.90237 20.1834 6.29289 19.7929L12.0858 14Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const chevronDownSmall = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.7364 9.26363C17.3849 8.91216 16.8151 8.91216 16.4636 9.26363L12 13.7272L7.53639 9.26363C7.18492 8.91216 6.61507 8.91216 6.2636 9.26363C5.91213 9.6151 5.91213 10.185 6.2636 10.5364L11.3636 15.6364C11.7151 15.9879 12.285 15.9879 12.6364 15.6364L17.7364 10.5364C18.0879 10.1849 18.0879 9.6151 17.7364 9.26363Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const chevronDownOutline = (props) => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M7.65081 11.2408C7.23148 10.8813 6.60018 10.9299 6.24076 11.3492C5.88134 11.7686 5.9299 12.3999 6.34923 12.7593L13.3492 18.7593C13.7237 19.0803 14.2763 19.0803 14.6508 18.7593L21.6508 12.7593C22.0701 12.3999 22.1187 11.7686 21.7593 11.3492C21.3999 10.9299 20.7686 10.8813 20.3492 11.2408L14 16.6829L7.65081 11.2408Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const chevronUpSmall = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.7364 14.7364C17.3849 15.0878 16.8151 15.0878 16.4636 14.7364L12 10.2728L7.53639 14.7364C7.18492 15.0878 6.61507 15.0878 6.2636 14.7364C5.91213 14.3849 5.91213 13.815 6.2636 13.4636L11.3636 8.36358C11.7151 8.01211 12.285 8.01211 12.6364 8.36358L17.7364 13.4636C18.0879 13.8151 18.0879 14.3849 17.7364 14.7364Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const chevronUpOutline = (props) => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M20.3492 16.7592C20.7685 17.1187 21.3998 17.0701 21.7592 16.6508C22.1187 16.2314 22.0701 15.6001 21.6508 15.2407L14.6508 9.24073C14.2763 8.91973 13.7237 8.91973 13.3492 9.24073L6.34919 15.2407C5.92986 15.6001 5.8813 16.2314 6.24073 16.6508C6.60015 17.0701 7.23145 17.1187 7.65077 16.7592L14 11.3171L20.3492 16.7592Z'
        fill='#023F80'
      />
    </svg>
  );
};
